<template>
  <div class="row no-gutters body" oncontextmenu="return false;">    
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loading">
    </div>
    <div class="col-12" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-lg-3 middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row row no-gutters">
            <br />
          </div>
          <div class="main-card pb-3 pb-lg-0">
            <div class="card shadow coursevideoDetailsCard mt-5 accordion-section ml-3 mr-3 ml-lg-0 mr-lg-0">
              <span class="proximanova-semibold fontsize16 black80 p-3">{{CorseTitle}}</span>
              <hr class="profhoriz ml-0 mr-0">
              <div class="panel-group text-left proximanova" id="accordion">
                    <div v-for="(faq, index) in section1" :key="index">
                        <div class="panel panel-default">
                            <div class="panel-heading p-3" @click="clickedOnIndividualTab(index)" :id="'heading'+index" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="true"  :aria-controls="'collapse'+index">
                                <h3 class="panel-title fontsize16 proximanova-bold pointer">
                                <a>
                                    <span class="proximanova-semibold">{{faq.title}}</span>
                                </a>
                                </h3>
                            </div>
                            <div :id="'collapse'+index" class="panel-collapse collapse" data-parent="#accordion" :aria-labelledby="'heading'+index">
                                <div class="panel-body px-3 mb-3 text-center">
                                <!-- <ul class="StepProgress pl-2">
                                    <span v-for="(item1, index1) in faq.sections" :key="index1">
                                      <li class="StepProgress-item d-flex"
                                        :class="{'is-done' :(item1.state == 0), 'current':(item1.state == 1)}">
                                        <img src="../assets/course_green_tick1.png" class="statusImg" title="Completed" v-if="item1.state == 0">
                                        <img src="../assets/course_blue_inprogress1.png" title="Inprogress" class="statusImg" v-if="item1.state == 1">
                                        <img src="../assets/course_gray_not_started1.png" title="Not yet started" class="statusImg" v-if="item1.state == 2">
                                        <div class="ml-2">
                                          <p class="fontsize14 black80 proximanova pointer ml-2 mt-1 coursehover" @click="DisplayContent(index1)">{{index1 + 1}} . {{item1.title}}</p>
                                        </div>
                                      </li>
                                    </span>
                                  </ul> -->
                                  <div v-if="courseVideoLoader" class="mx-auto">
                                    <img src="../assets/loading_gif1.gif" class="instanceloader pb-3 text-center" alt="loading">
                                  </div>
                                  <span v-else>
                                    <ul class="pl-2" v-if="videosList.length > 0">
                                      <span v-for="(item1, index1) in videosList" :key="index1">
                                        <li class="d-flex">
                                          <img v-if="item1.isPlaying" src="../assets/course_video_pause.png" alt="videopause" title="Not yet started" class="statusImg">
                                          <img v-else src="../assets/course_video_play.png" alt="videoplay" title="Not yet started" class="statusImg">
                                          <div class="ml-2">
                                            <p class="fontsize14 black80 proximanova pointer mt-1 coursehover" @click="PlayVideo(item1, index1)">Video {{index1 + 1}}</p>
                                          </div>
                                        </li>
                                      </span>
                                    </ul>
                                    <span v-else>
                                      <span class="text-center proximanova black60 fontsize12 p-3">Not yet uploaded...</span>
                                    </span>
                                  </span>
                                </div>
                            </div>
                        </div>
                        <div class="profhoriz" v-if="index < section1.length-1"></div>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="col-md-12 col-lg-6 pb-5 pb-lg-0 middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters mt-lg-5" v-if="displayvideo">
            <div class="col-lg-12 pb-3 coursevideoDetailsCard1">
              <div class="row no-gutters">
                <br />
              </div>
              <div class="main-card ">
                <div class="shadow card mb-2 ml-3 mr-3 mt-lg-2">
                  <div class="card-body homevideoslist" :id="'videoCardItem'">
                    <div class="d-flex flex-column">
                      <div class="videocardbody" v-if="displayvideoItem">
                          <span>
                            <video controlsList="nodownload" :src="selectedVideoURL" controls muted autoplay  
                             @error ="videoLoading()" @loadedmetadata="LoadVideoMetaData()" @pause="videoPause()" v-on:play="videoPlay()"
                            oncontextmenu="return false;" class="postedvideoItem portraitvideheight" :id="'postvideo'" preload="metadata" webkit-playsinline playsinline>
                            </video>
                          </span>                      
                      </div>
                      <div class="d-flex flex-column p-4">
                        <span class="proximanova-semibold black fontsize20">About this course</span>
                        <span class="proximanova black80 fontsize14">Become a Full-Stack Web Developer with just ONE course. HTML, CSS, Javascript, Node, React, MongoDB, build real projects</span>
                      </div> 
                      <div class="profhoriz mb-1"></div>
                      <div class="d-md-flex col-12 p-4 mb-3">
                        <div class="col-md-3 pl-0 pr-0">
                          <span class="proximanova-semibold fontsize18 black60">Description</span>
                        </div>
                        <div class="col-md-9 pl-0 pr-0">
                          <span class="proximanova fontsize16 black60">{{courseDescription1}}</span><br>
                          <span class="proximanova fontsize16 black60 mt-3">{{courseDescription2}}</span>
                        </div>
                      </div>             
                    </div>                    
                  </div>                  
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters mt-5" v-if="displaySubmitQuiz">
            <div class="col-lg-12 pb-3 coursevideoDetailsCard1">
              <div class="row no-gutters">
                <br />
              </div>
                <div class="shadow card mb-2 ml-3 mr-3 mt-lg-2" >
                  <p class="proximanova-semibold fontsize24 black ml-3 p-3 mb-1">Business Model Assignment (Optional)</p> 
                  <hr class="profhoriz ml-0 mr-0 mt-0 mb-0">   
                  <div class="col-12 d-flex mt-4 pb-4">
                    <div class="col-7 d-flex flex-column">
                      <div class="d-flex">
                        <img src="../assets/file_instructions.png" height="30px" alt="file">
                        <span class="proximanova-semibold fontsize20 ml-2 black">Submission Details</span>
                      </div>
                      <span class="proximanova-semibold fontsize18 black60 mt-3">Instructions</span>
                      <div>
                        <ul>
                          <li class="proximanova-semibold fontsize16 black60 mt-3">Download the "Business Model Canvas Template" to complete the assignment</li>
                          <li class="proximanova-semibold fontsize16 black60 mt-3">Use the template to fill the details in each of the boxes available.</li>
                          <li class="proximanova-semibold fontsize16 black60 mt-3">Once you are done, please convert the file to pdf and upload it. </li>
                        </ul>
                      </div>
                      <span class="proximanova-semibold fontsize16 black60 mt-3">We strognly recommend you to submit atleast 30 minutes before you deadline.</span>
                      <span class="proximanova-semibold fontsize20 black mt-3">Sample file</span>
                      <div class="d-flex mt-3 mb-2">
                        <img src="../assets/file_download.png" height="30px" class="mx-auto" alt="file upload">
                        <span class="proximanova-semibold fontsize20 underline blue ml-2 pointer">Business+Model+Canvas+Template.docs</span>
                      </div>
                    </div>
                    <div class="col-5">
                      <div class="col-10 d-flex flex-column borderblack60 borderadius12 p-3">
                        <div class="d-flex">
                          <img src="../assets/file_timer.png" height="20px" alt="file timer">
                          <span class="proximanova-semibold fontsize16 ml-2 black60 my-auto">Module deadline</span>
                        </div>
                        <span class="proximanova-semibold fontsize18 black60 mt-2">30 Apr '20</span>
                        <span class="proximanova-semibold fontsize18 black60 mt-2">11:50 PM (IST)</span>
                      </div>
                    </div>
                  </div>    
                  <div class="col-11 mx-auto mb-5 borderblack60dotted p-4 text-center borderadius12 d-flex flex-column">
                    <img src="../assets/file_upload.png" width="45" class="img-fluid mx-auto" alt="file upload">
                    <span class="proximanova-semibold fontsize18 black60 mt-2">Upload your file & save as draft</span>
                    <span class="proximanova-semibold fontsize18 black60 mt-1">Accepted formats: .pdf, .txt</span>
                    <input type="file" class="form-control-file" id="courseassignment" accept="text/plain, application/pdf" @change="onPdfSelected"
                      @click="UploadAssignmentDocs"
                      hidden
                    />
                    <button class="uploadbtn proximanova mx-auto mt-4" @click="UploadAssignmentDocs">Upload</button>
                  </div>        
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default {
    components: {
  },
  data(){
      return {
        section1 : [
          { 
            title : "Section 1 : Introduction",
            sections : [{title : 'What you will get in this course', state : 0},{title :'Introduction', state : 1}, {title :'Upload Answers', state : 2}]
          },
          { 
            title : "Section 2 : Variables & OOPS",
            sections : [{title : 'What you will get in this course', state : 1},{title :'Introduction', state : 1}, {title :'Upload Answers', state : 2}]
          },
          // { 
          //   title : "Section 3 : Introduction to CSS",
          //   sections : [{title : 'What you will get in this course', state : 0},{title :'Introduction', state : 1}, {title :'Upload Answers', state : 2}]
          // },
          // { 
          //   title : "Section 4 : Introduction to CSS flexbox",
          //   sections : [{title : 'What you will get in this course', state : 1},{title :'Introduction', state : 1}, {title :'Upload Answers', state : 2}]
          // },
          // { 
          //   title : "Section 5 : Introduction to javascript",
          //   sections : [{title : 'What you will get in this course', state : 0},{title :'Introduction', state : 1}, {title :'Upload Answers', state : 2}]
          // },
          // { 
          //   title : "Section 6 : Introduction to Typescript",
          //   sections : [{title : 'What you will get in this course', state : 1},{title :'Introduction', state : 1}, {title :'Upload Answers', state : 2}]
          // },
          // { 
          //   title : "Section 7 : Introduction to Angularjs",
          //   sections : [{title : 'What you will get in this course', state : 0},{title :'Introduction', state : 1}, {title :'Upload Answers', state : 2}]
          // }
        ],
        CorseTitle : "Java full stack course",
        courseDescription1 : "Welcome to the Complete Web Development Bootcamp, the only course you need to learn to code and become a full-stack web developer. With 150,000+ ratings and a 4.8 average, my Web Development course is one of the HIGHEST RATED courses in the history of Careertuner! ",
        courseDescription2 : "At 55+ hours, this Web Development course is without a doubt the most comprehensive web development course available online. Even if you have zero programming experience, this course will take you from beginner to mastery.",
        //display cards based on selection
        displayvideo : true,
        displayvideoItem : false,
        displaySubmitQuiz : false,
        courseVideoLoader : false,
        sectionTypes : ["introduction", "Variables_OOPS"],
        selectedSectionIndex : null,
        videosList : [],
        selectedVideoURL : null,
        selectedVideoIndex : null,
        currentUserProfilePic: null,
        currentUser: [],
        pageloader: true,
        videoWatched: false,
        currentTime : 0,
      }
  },
  methods:{
    clickedOnIndividualTab(index){
      console.log("clicked on course section : ", index)
      if(this.selectedSectionIndex !== index){
        console.log("different section.")
        this.courseVideoLoader = true;
        this.selectedSectionIndex = index;
        let selectedSection = this.sectionTypes[this.selectedSectionIndex]
        this.getCourseVideos(selectedSection)
      }else{
        console.log("same section")
      }
    },
    getCourseVideos(selectedSection){
      console.log("sleected section : ", selectedSection)
      this.videosList = [];
      httpuserprofile.get('/userprofile/getAllJavaVideos?modulePath='+selectedSection)
      .then((response) => {
        console.log("introduction videos : ", response.data)
        let list = response.data;
        for(var i =0; i < list.length; i++){
          let obj = {
            videoLink : list[i],
            isPlaying : false
          }
          this.videosList.push(obj)
        }
        //this.videosList = response.data;
        this.courseVideoLoader = false;
      }).catch((e) => {
        console.log(e)
        this.courseVideoLoader = false;
      })
    },
    PlayVideo(video1, index1) {
      this.displayvideoItem = true;
      // console.log("videoitem : ", video);
      // console.log("index : ", index1)
      var video = document.getElementById("postvideo")
      // video.src = null;
      // this.selectedVideoURL = null;
      this.selectedVideoURL = video1.videoLink;
      for(var i = 0; i < this.videosList.length; i++){
        if(index1 !== i){
          this.videosList[i].isPlaying = false;
        }
        if(index1 == i && video1.isPlaying){
          console.log("smae video already playing")
          video1.isPlaying = false;
          video.pause()
        }else if(index1 == i && !video1.isPlaying ){
          console.log("smae video not playing")
          if(this.selectedVideoIndex !== index1){
          this.selectedVideoIndex = index1;
          video.removeAttribute('src')
          video.load()
          this.selectedVideoURL = video1.videoLink;
          video.setAttribute('src', this.selectedVideoURL)
          video1.isPlaying = true;
          video.load();
          }else{
            video1.isPlaying = true;
            video.play()
          }
        }
      }
      // video.play()
    },
    DisplayContent(index1) {
      if(index1 == 0 || index1 == 1){
        this.displayvideo = true;
        this.displaySubmitQuiz = false;
      }else{
        this.displayvideo = false;
        this.displaySubmitQuiz = true;
      }
    },
    onPdfSelected(event) {
      console.log("check : ", event.target.files)
      var file = event.target.files[0];
      console.log("file type : ", file.type)
    },
    UploadAssignmentDocs(){
      var fileInput = document.getElementById("courseassignment")
      fileInput.click()
    },
    LoadVideoMetaData(){
      var video = document.getElementById("postvideo")
      // console.log("loading meta : ", video.readyState)
      if(video.readyState >= 0){
        video.play()
      }
    },
    videoLoading(){
      this.selectedVideoURL = null;
    }, 
    // this wil invoke after video is playing
    // if the video is reached half of its duration make a call (view video) to increase views count of video
    videoPlay(){
      var video = document.getElementById("postvideo");      
      // videoitem.videoDuration = video.duration;
      // var currentTime = videoitem.videoDuration * (50/100);     
      var self= this  ;
      // console.log("resume")
      this.currentTime = video.currentTime;
      //  console.log("selected index", this.selectedVideoIndex)
      this.videosList[this.selectedVideoIndex].isPlaying = true;             
      video.ontimeupdate = function(){
        // if(currentTime < video.currentTime && !videoitem.videoWatched){      
          // videoitem.videoWatched = true;  
          // self.currentTime = video.currentTime;   
          if (!video.seeking) {
            self.currentTime = video.currentTime;
          }
          // console.log("updating", self.currentTime)       
            //self.viewVideo(videoitem);
        // }        
      };
      video.onseeking = function() {
          // console.log("User jump or forward time");
          var delta = video.currentTime - self.currentTime;
          if (Math.abs(delta) > 0.01 && video.currentTime >= self.currentTime) {
            console.log("Seeking is disabled");
            video.currentTime = self.currentTime;
          }
      };
      video.onended = function() {
        console.log("after ended")
        self.currentTime = 0;
        video.currentTime = 0;
      }
    },
    // this will invoke after pause any video
    videoPause(){
      console.log("video paused")
      for(var i =0; i < this.videosList.length; i++){
        if(this.selectedVideoIndex == i){
          this.videosList[i].isPlaying = false;
        }
      }
      // var video = document.getElementById("postvideo");
      // if(!videoitem.pausefromScroll){        
      //   videoitem.videoPaused = true;
      // }      
    },
    // this will invoke when user view any video morethan a half of its original duartion
    viewVideo: function(video){
    if(video.viewVideoFlag === 'N' && this.currentUserProfileId !== video.profileId){   
      var fd = new FormData(); 
        var obj = {
        profileId : this.currentUserProfileId,
        videoId: video.id,
        videoProfileId: video.profileId,
        viewed_sec : 0,
        video_type : 'POSTVIDEO',
        video_duration : 1
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoViews", blob)
      fd.append("duration", 1)
      httpuserprofile.post("/userprofile/viewVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      })
      .then(response => {   
        if(response.data.errorCode === 1030){
          video.videoWatched = false
          video.isPlaying = true;
          video.viewVideoFlag = 'Y';
          video.noOfViews = video.noOfViews+1;
        }                           
      }) .catch((e) => {
        console.log(e)
      })       
    }
  },
      //get current user information
      getUserByID(){
        this.currentUserId =sessionUtils.getUserId();
        httpuserprofile
        .get("/userprofile/userbyid/" + this.currentUserId)
        .then(response => {
          response.data['isPlaying'] = false;
             this.currentUserProfileId = response.data.profileId; 
            this.currentUser = response.data;
            this.currentUserProfilePic = response.data.profilePictureLink; 
            if(this.currentUserProfileId) {
              this.pageloader = false;
            }else{
              this.pageloader = false;
            }
        }).catch((e) => {
        console.log(e)
      })
    }, 
  },
  created(){              
      window.scrollTo(0, 0);
      this.currentUserProfileId = sessionUtils.getUserProfileId();
      this.getUserByID();
      if(!this.currentUserProfileId){
        this.pageloader = false;
      }
    },
    mounted(){
      document.body.style.scale = "100%";
    },    
    destroyed() {      
    }
}

</script>
<style scoped>
html,
body,
.grid {
   height: 100%;
  width: 100%;
    /* margin: -.89px; */
}
.profhoriz {
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 15px;
  margin-right: 15px;
  border-top: 1.5px solid rgba(0,0,0,.1)
}
.instanceloader{
  width: 30px;
  /* margin-left: 46% !important; */
}
.accordion-section .panel-default .panel-title a:after {
    font-family: 'FontAwesome';
    font-style: normal;
    font-size: 2.5rem;
    /* content: "\f106"; */
    /* content: url("../assets/arrow.svg"); */
    content: url("../assets/arrowdown.svg");
    float: right;
    /* color: #1f7de2; */
    float: right;
    margin-top: -25px;
}
.accordion-section .panel-default .panel-title a.collapsed:after {
    /* content: "\f107"; */
    content: url("../assets/arrowdown.svg");
}
.accordion-section .panel-default .panel-body {
    font-size: 1rem;
}
/* .reportcard11.collapsed:after{
  content: url("../assets/arrowdown.svg");
}
.reportcard11:after{
  content: url("../assets/arrow.svg");
  float: right;
} */
.uploadbtn{
  background: #007AFF;
  color: white;
  border-radius: 5px;
  border: none;
  width: 150px;
  padding: 5px;
}
.uploadbtn:focus{
  outline: none;
}
.statusImg{
    vertical-align: baseline;
    width: 25px;
    height: 25px;
    z-index: 3;
    background: white;
    cursor: pointer;
}
.StepProgress {
  position: relative;
  list-style: none;
}
.StepProgress::before {
  display: inline-block;
  content: '';
  position: absolute;
  top: 0;
  width: 10px;
  height: 100%;
    margin-left: 12px;
    border-left: 2px solid #CCC;
}
  a{
    color: black;
  }
  .StepProgress-item {
    display: flex;
    position: relative;
    counter-increment: list;
  }
  .coursehover:hover {
    /* background: rgba(0,0,0,.1); */
    color: #007AFF !important;
  }
  .StepProgress-item:not(:last-child) {
      padding-bottom: 20px;
    }
    
    .StepProgress-item::before {
      display: inline-block;
      content: '';
      position: absolute;
      left: -30px;
      height: 100%;
      width: 10px;
    }
    
    .StepProgress-item::after {
      position: absolute;
      top: 0;
      left: -37px;
      width: 30px;
      margin-left: 10px;
        height: 30px;
        color: #CCC;
        text-align: center;
      border: 2px solid #CCC;
      border-radius: 50%;
      background-color: #FFF;
    }
    
        .is-done::before {
        border-left: 2px solid#1EC6A0;
        margin-left: 42px;
      }
      .is-done::after {
        color: #FFF;
        text-align: center;
        border: 2px solid #1EC6A0;
        background-color: #1EC6A0;
      }
      .is-done1::before {
        border-left: 2px solid#1EC6A0;
        margin-left: 42px;
      }
      .is-done1::after {
        color: #FFF;
        text-align: center;
        border: 2px solid #1EC6A0;
        background-color: #1EC6A0;
      }
        .current::before {
        border-left: 2px solid #007AFF;
        margin-left: 42px;
      }
      
      .current::after {
        font-size: 14px;
        text-align: center;
        color: #007AFF;
        border: 2px solid #007AFF;
        background-color: white;
      }
      /* end of new styles */
.nameBlock:hover{
color:#007AFF;
cursor: pointer;
}
.homevideoslist{
  padding: 0 !important;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}

.coursevideoDetailsCard::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.coursevideoDetailsCard {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    background-attachment: scroll;
    overflow: hidden;
    z-index: 0;
    border-radius: 10px 10px 0 0;
}
.videocardbody video {
  background-color: #1F1F1F;
    min-width: 100%;
    width: 100%;
    min-height: 100%;
    position: relative;
    z-index: 1;
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    background: rgba(31, 31, 31, .6);
    opacity: 0.5;
    margin-top: -5px;
}
#postedvideoItem{
  width: 100%;
  border: 1px solid #1F1F1F;
  border-radius: 10px 10px 0 0;
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
}
@media screen and (max-width: 600px) {
  .videocardbody video {
    width: 100%  !important;
  }
}
@media screen and (min-width: 770px) {
  .coursevideoDetailsCard{
    height: 85vh;
    overflow: auto;
  }
  .coursevideoDetailsCard1{
    height: 90vh;
    overflow: auto;
  }
  .portraitvideheight{
    height: 400px;
  }
}
</style>
